import { default as LazyLoad, LazyLoadProps } from 'react-lazyload';
import * as React from 'react';

import { UitkCardPlaceholder } from 'uitk-react-cards';

interface SimpleLazyLoadWrapperProps extends LazyLoadProps {
  placeholder?: any;
  children: any;
}

/**
 * This component simplified lazy loading - @jullberg
 */
export const SimpleLazyLoadWrapper: React.FunctionComponent<SimpleLazyLoadWrapperProps> = ({
  children,
  placeholder = <UitkCardPlaceholder />,
  ...props
}) => (
  <LazyLoad once placeholder={placeholder} {...props}>
    {children}
  </LazyLoad>
);
